import React, { useContext, useEffect } from "react";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { useTranslation } from "react-i18next";
import ProductEditComponent from "../../components/Products/ProductEditComponent";


export default function AddProduct() {
  const { t } = useTranslation()
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)


  useEffect(() => {
    setnavLinks([{ path: "/dashboard/user/myproducts", label: "productList" }])
    setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
    setpageTitle("addProduct")
    setalertTitle("")
  }, [])


  return (
    <ProductEditComponent />
  )


};

